import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';

import { verifyEmail } from '../../actions'
import { pushError } from '../../../global/actions';
import ShowErrorToast from '../../../global/errorToast';

const mapStateToProps = state => ({
  registration: state.Registration
});

class VerifyEmailLogin extends Component {
  constructor(props) {
    super(props);

    this.verifyLoginURL = this.verifyLoginURL.bind(this);
  }

  verifyLoginURL = () => {
    let { location, dispatch } = this.props;
    const query = queryString.parse(location.search);
    if (query.t && query.e) {
      dispatch(verifyEmail(query.t, query.e));
    } else {
      dispatch(pushError('Verification URL is Invalid!'));
    }
  }

  componentDidMount() {
    this.verifyLoginURL();
  }

  render() {
    return (
      <div className="main-container">
        <ShowErrorToast />
      </div>
    )
  }
}

export default withRouter(connect(mapStateToProps)(VerifyEmailLogin));
